import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IrbCommonModule } from '@irb-common/irb-common.module';
import { SettingsDialogComponent } from './settings-dialog/settings-dialog.component';
import { SettingsSecuritiesComponent } from './settings-securities/settings-securities.component';
import { SettingsAccountsComponent } from './settings-accounts/settings-accounts.component';
import { SettingsPortfoliosComponent } from './settings-portfolios/settings-portfolios.component';
import { SettingsModelsRebalancingComponent } from './settings-models-rebalancing/settings-models-rebalancing.component';
import { SettingsLogicComponent } from './settings-logic/settings-logic.component';
import { SettingsOrdersComponent } from './settings-orders/settings-orders.component';
import { SettingsMmcComponent } from './settings-mmc/settings-mmc.component';
import { NotANumberValidatorDirective } from '@irb-common/validators/numberValidator';
import { SettingsDialogBannerComponent } from './settings-dialog-banner/settings-dialog-banner.component';
import { DeleteAssetCategorydialogComponent } from './settings-securities/delete-asset-category-dialog/delete-asset-category-dialog.component';
import { MorningstarCategoriesAutomaticMappingDialogComponent } from './settings-securities/Morningstar-categories-automatic-mapping-dialog/morningstar-categories-automatic-mapping-dialog.component';
import { MmcAssetTypeSettingsComponent } from './settings-mmc/mmc-asset-type-settings/mmc-asset-type-settings.component';
import { MmcAssetClassSettingsComponent } from './settings-mmc/mmc-asset-class-settings/mmc-asset-class-settings.component';
import { MmcRiskToleranceSettingsComponent } from './settings-mmc/mmc-risk-tolerance-settings/mmc-risk-tolerance-settings.component';
import { MmcBillingDefaultsSettingsComponent } from './settings-mmc/mmc-billing-defaults-settings/mmc-billing-defaults-settings.component';
import { SettingsMmcNotesComponent } from './settings-mmc/settings-mmc-notes/settings-mmc-notes.component';
import { SettingsAnnouncementsComponent } from './settings-announcements/settings-announcements.component';
import { SettingsAutoTradeComponent } from './settings-auto-trade/settings-auto-trade.component';
import { SettingsHistoryComponent } from '@irb/irb-settings/settings-history/settings-history.component';
import { ComViewAssetClassesDialogComponent } from './settings-securities/com-view-asset-classes-dialog/com-view-asset-classes-dialog.component';
import { ReportingInvoiceComponent } from './settings-mmc/reporting-invoice/reporting-invoice.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IrbCommonModule
  ],
  declarations: [
    SettingsDialogComponent, 
    SettingsSecuritiesComponent, 
    SettingsAccountsComponent, 
    SettingsPortfoliosComponent, 
    SettingsModelsRebalancingComponent, 
    SettingsLogicComponent, 
    SettingsOrdersComponent, 
    SettingsMmcComponent,
    DeleteAssetCategorydialogComponent,
    NotANumberValidatorDirective,
    SettingsDialogBannerComponent,
    MorningstarCategoriesAutomaticMappingDialogComponent,
    MmcAssetTypeSettingsComponent,
    MmcAssetClassSettingsComponent,
    MmcRiskToleranceSettingsComponent,
    MmcBillingDefaultsSettingsComponent,
    SettingsMmcNotesComponent,
    SettingsAnnouncementsComponent,
    SettingsAutoTradeComponent,
    SettingsHistoryComponent,
    ComViewAssetClassesDialogComponent,
    ReportingInvoiceComponent
  ],
  providers: [DeleteAssetCategorydialogComponent, MorningstarCategoriesAutomaticMappingDialogComponent],
  exports: [DeleteAssetCategorydialogComponent, MorningstarCategoriesAutomaticMappingDialogComponent]
})
export class IrbSettingsModule { }
